module.exports = __webpack_public_path__ + "static/media/Beach3.260ce069.jpg";